export type CommunityBadgePalette = {
  accents: string[];
  bg: string;
};

export const COMMUNITY_BADGE_PALETTES: CommunityBadgePalette[] = [
  {bg: '#F6F0E2', accents: ['#1D1B1A', '#6A3D2E', '#C07A4A', '#E7B47A']},
  {bg: '#E7F0F8', accents: ['#1F2C3A', '#2D4E7A', '#5A8ACB', '#9BC3EE']},
  {bg: '#F1F7ED', accents: ['#1C2B1B', '#3E6B3E', '#6E9F6B', '#A7CFA1']},
  {bg: '#F9EDF0', accents: ['#2A1B1F', '#6E2C3A', '#B85C6A', '#E2A1AC']},
  {bg: '#F3F0FA', accents: ['#2B2036', '#4C2E6C', '#7B4CA0', '#B08AD2']},
];

export const hashCommunityBadgeSeed = (value: string): number => {
  let hash = 2166136261;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
  }
  return hash >>> 0;
};

const mulberry32 = (seed: number): (() => number) => {
  let t = seed;
  return () => {
    t += 0x6d2b79f5;
    let result = Math.imul(t ^ (t >>> 15), t | 1);
    result ^= result + Math.imul(result ^ (result >>> 7), result | 61);
    return ((result ^ (result >>> 14)) >>> 0) / 4294967296;
  };
};

export const buildCommunityBadgePixelArt = (
  seedValue: string,
  gridSize: number,
): {bg: string; palette: CommunityBadgePalette; pixels: {color: string; x: number; y: number}[]} => {
  const seed = hashCommunityBadgeSeed(seedValue);
  const palette = COMMUNITY_BADGE_PALETTES[seed % COMMUNITY_BADGE_PALETTES.length];
  const rand = mulberry32(seed);
  const half = Math.ceil(gridSize / 2);
  const pixels: {x: number; y: number; color: string}[] = [];

  for (let y = 0; y < gridSize; y += 1) {
    for (let x = 0; x < half; x += 1) {
      const shouldFill = rand() > 0.45;
      if (!shouldFill) continue;
      const color = palette.accents[Math.floor(rand() * palette.accents.length)];
      pixels.push({x, y, color});
      const mirrorX = gridSize - 1 - x;
      if (mirrorX !== x) {
        pixels.push({x: mirrorX, y, color});
      }
    }
  }

  return {bg: palette.bg, pixels, palette};
};
